import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { chapters } from '../data/horizon';
type ChapterProps = {
  i: number;
  children: React.ReactNode;
};
export function Chapter({
  i,
  children
}: ChapterProps) {
  const c = chapters[i];
  const Icon = c.icon;
  const reduceMotion = useReducedMotion();
  return <section id={c.id} aria-labelledby={`${c.id}-t`} className="scroll-mt-20 md:scroll-mt-28 border-t border-white/10 py-7 md:py-24 first:border-t-0 first:pt-0" data-id="element-72" data-mp="2lpued0ax7bx6">
      <motion.header className="mb-3 md:mb-10" initial={reduceMotion ? false : {
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-10% 0px'
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-73" data-mp="2vmp8l705uq5n">
        <div className="flex flex-wrap items-center gap-2 md:gap-4 mb-2 md:mb-5" data-id="element-74" data-mp="39edlhci8hino">
          <span className="font-cinzel text-2xl md:text-6xl font-black text-[#D4AF37]/25 leading-none select-none" aria-hidden="true" data-id="element-75" data-mp="39c990669rbbs">
            {String(i + 1).padStart(2, '0')}
          </span>
          <span className="flex h-8 w-8 md:h-11 md:w-11 items-center justify-center rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 text-[#D4AF37]" data-id="element-76" data-mp="3hp7t3coina27">
            <Icon className="h-4 w-4 md:h-5 md:w-5" aria-hidden="true" data-id="element-77" data-mp="38rnnjrjmerls" />
          </span>
          {c.status && <span className="ml-auto rounded-full border border-[#4A9EFF]/30 bg-[#4A9EFF]/10 px-2 md:px-3 py-1 text-[11px] md:text-xs font-semibold text-[#4A9EFF] whitespace-nowrap" data-id="element-78" data-mp="33t417q147dsw">
              {c.status}
            </span>}
        </div>
        <h2 id={`${c.id}-t`} className="font-cinzel text-white text-lg leading-snug sm:text-3xl md:text-4xl lg:text-[2.75rem] md:leading-tight font-bold max-w-3xl" data-id="element-79" data-mp="3rp8h3bxbyecq">
          {c.title}
        </h2>
      </motion.header>
      <div className="space-y-3 md:space-y-6 text-sm md:text-lg leading-snug md:leading-relaxed text-gray-300" data-id="element-80" data-mp="o0n6vk91884m">{children}</div>
    </section>;
}